import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import UnAuthenticatedRequest from 'services/requests/UnAuthenticated';

const URLS = {
  ISSUED_REWARDS: `${apiUrlConfig.apiEndPoint()}/businesses/:id/rewards/issued`,
  ALL_REWARDS: `${apiUrlConfig.apiEndPoint()}/businesses/:id/rewards`,
  REDEEM_REWARD: `${apiUrlConfig.apiEndPoint()}/rewards/:id/redeem`,
  UNAUTHORIZED_REDEEM: `${apiUrlConfig.apiEndPoint()}/rewards/:id/unauthorized_redeem`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class RewardApi {
  /**
   * gets all issued rewards for a business
   */
  static getAllIssued(businessId) {
    const INDEX_URL = insertIdToUrl(URLS.ISSUED_REWARDS, businessId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * gets all redeemed rewards for a business
   */
  static getAll(businessId) {
    const INDEX_URL = insertIdToUrl(URLS.ALL_REWARDS, businessId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * sends reward ro be redeemed
   */

  static redeemCoupon(rewardId, user) {
    const REDEEM_URL = insertIdToUrl(URLS.REDEEM_REWARD, rewardId);
    const data = {
      user,
    };
    return AuthenticatedRequestService.post(REDEEM_URL, data);
  }

  static unauthorizedRedeem(rewardId, user) {
    const UNAUTHORIZED_REDEEM_URL = insertIdToUrl(URLS.UNAUTHORIZED_REDEEM, rewardId);
    const data = {
      user,
    };
    return UnAuthenticatedRequest.post(UNAUTHORIZED_REDEEM_URL, data);
  }
}

export default RewardApi;



// WEBPACK FOOTER //
// ./src/apis/RewardApi.js